function deleteItem(id, model, force, type) {
  confirmDelete([id], model, force, type);
}

function deleteItems(model, force, type) {
  var ids = getSelectedIds();
  if (ids.length) {
    confirmDelete(ids, model, force, type);
  }
  closeMultiselectOptions();
}

function confirmDelete(ids, model, force, type) {
  if (!app.confirmDeleteModal) {
    app.confirmDeleteModal = new jBox('Modal', {
      addClass: 'modal__wrapper',
      adjustDistance: 16,
      closeButton: 'title',
      getTitle: 'data-title',
      width: 480,
      title: 'Löschen',
      content: '',
      createOnInit: true,
      zIndex: 11000,
      onCreated: function () {
        // Fix close button
        setModalCloseButton(this.wrapper);

        // Create content
        var contentWrapper = $('<div class="modal-delete__content-wrapper"/>');
        var contentContainer = $(
          '<div class="modal-delete__content-container"/>'
        ).appendTo(contentWrapper);

        contentContainer.append($('<div/>').html('Löschbestätigung für'));

        contentContainer.append(
          $('<div class="modal-delete__content-preview"/>')
        );

        contentContainer.append(
          $('<div class="modal-delete__content-title"/>')
        );

        contentContainer.append(
          $('<div class="modal-delete__forever"/>').html(
            'Kann nicht rückgängig gemacht werden!'
          )
        );

        var mlReferenceNoticeContainer = $(
          '<div class="modal-delete__references-notice-container"/>'
        );
        mlReferenceNoticeContainer.appendTo(contentContainer);

        var mlReferenceCheckboxContainer = $(
          '<div class="modal-delete__references-checkbox-container"/>'
        );
        mlReferenceCheckboxContainer.on('click', function () {
          var container = $(this);
          var checked = container.attr('data-checked');
          container.attr('data-checked', checked == '1' ? '0' : '1');
        });
        mlReferenceCheckboxContainer.appendTo(mlReferenceNoticeContainer);

        var mlReferenceCheckbox = $(
          '<div class="modal-delete__references-checkbox icon-link"/>'
        );
        var mlReferenceCheckboxHtml = '';
        mlReferenceCheckboxHtml +=
          '<svg class="modal-delete__references-checkbox-icon modal-delete__references-checkbox-icon--checkbox-blank" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M19 5v14H5V5h14m2-2H3v18h18V3z"></path></svg>';
        mlReferenceCheckboxHtml +=
          '<svg class="modal-delete__references-checkbox-icon modal-delete__references-checkbox-icon--checkbox-checked" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M21 3H3v18h18V3zM10 17l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path></svg>';
        mlReferenceCheckbox.html(mlReferenceCheckboxHtml);
        mlReferenceCheckbox.appendTo(mlReferenceCheckboxContainer);

        var mlReferenceNotice = $(
          '<div class="modal-delete__references-notice"/>'
        );
        mlReferenceNotice.appendTo(mlReferenceNoticeContainer);

        var buttonsWrapper = $(
          '<div class="modal-delete__buttons-wrapper"/>'
        ).appendTo(contentWrapper);

        $('<div class="modal-delete__buttons-container"/>')
          .html(
            '<button class="button button--block button--light modal-delete__cancel-button">Abbrechen</button>'
          )
          .on(
            'click',
            function () {
              this.close();
            }.bind(this)
          )
          .appendTo(buttonsWrapper);

        $('<div class="modal-delete__buttons-container"/>')
          .html(
            '<button class="button button--block modal-delete__submit-button">Löschen</button>'
          )
          .appendTo(buttonsWrapper);

        this.content.html(contentWrapper);

        this.disableForm = function () {
          $('.modal-delete__submit-button, .modal-delete__cancel-button').attr(
            'disabled',
            'disabled'
          );
        };

        this.enableForm = function () {
          $(
            '.modal-delete__submit-button, .modal-delete__cancel-button'
          ).removeAttr('disabled');
        };

        this.addLoadingStatus = function () {
          $('.modal-delete__submit-button').addClass('loading-bar');
        };

        this.removeLoadingStatus = function () {
          $('.modal-delete__submit-button').removeClass('loading-bar');
        };
      },
      onOpen: function () {
        this.enableForm();
        this.removeLoadingStatus();
        $(document).on(
          'keypress.submitDelete',
          function (ev) {
            if (ev.key == 'Enter') {
              this.content
                .find('.modal-delete__submit-button')
                .trigger('click');
              return false;
            }
          }.bind(this)
        );
      },
      onClose: function () {
        $(document).off('keypress.submitDelete');
      }
    });
  }

  // Type
  app.confirmDeleteModal.wrapper.attr('data-type', type ? type : 'default');

  // Title
  if (ids.length == 1) {
    var title = $(
      '.list-item__row[data-id="' +
        ids[0] +
        '"] .list-item__column[data-id="title"]'
    ).text();
  } else {
    var title =
      ids.length +
      ' ausgewählte ' +
      (type == 'ml-image'
        ? 'Bilder'
        : type == 'ml-document'
        ? ' Dokumente'
        : 'Einträge');
  }

  app.confirmDeleteModal.content
    .find('.modal-delete__content-title')
    .html(title);

  // Media library preview
  if (ids.length == 1 && (type == 'ml-image' || type == 'ml-document')) {
    var preview = $(
      '.list-item__row[data-id="' + ids[0] + '"] .list-item__media-preview'
    ).clone();

    app.confirmDeleteModal.content
      .find('.modal-delete__content-preview')
      .html('')
      .append(preview)
      .addClass('modal-delete__content-preview--active');
  } else {
    app.confirmDeleteModal.content
      .find('.modal-delete__content-preview')
      .html('')
      .removeClass('modal-delete__content-preview--active');
  }

  // References notice
  $('.modal-delete__references-notice-container').removeClass(
    'modal-delete__references-notice-container--active'
  );

  $('.modal-delete__references-checkbox-container').attr('data-checked', '0');

  if (type == 'ml-image' || type == 'ml-document') {
    var hasReferences = false;

    $.each(ids, function (index, id) {
      var reverences = parseInt(
        $(
          '.media-library__wrapper .list-item__row--body[data-id="' +
            id +
            '"] .list-item__icon--delete'
        ).attr('data-references')
      );
      if (reverences > 0) {
        hasReferences = true;
        return false;
      }
    });

    if (hasReferences) {
      $('.modal-delete__references-notice-container').addClass(
        'modal-delete__references-notice-container--active'
      );

      if (ids.length == 1) {
        var typeName = type == 'ml-image' ? 'Bild' : 'Dokument';
        var referenceNoticeText =
          'Dieses ' +
          typeName +
          ' wird in Beiträgen verwendet. Wenn es gelöscht wird, werden auch die Verlinkungen gelöscht. Bitte die Löschung bestätigen.';
      } else {
        var typeName = type == 'ml-image' ? 'Bilder' : 'Dokumente';
        var referenceNoticeText =
          'Einige dieser ' +
          typeName +
          ' werden in Beiträgen verwendet. Wenn sie gelöscht werden, werden auch die Verlinkungen gelöscht. Bitte die Löschung bestätigen.';
      }
      app.confirmDeleteModal.content
        .find('.modal-delete__references-notice')
        .html(referenceNoticeText);
    }
  }

  // Force notice
  app.confirmDeleteModal.content
    .find('.modal-delete__forever')
    [force ? 'addClass' : 'removeClass']('modal-delete__forever--active');

  // Event
  app.confirmDeleteModal.content
    .find('.modal-delete__submit-button')
    .off('click')
    .on('click', function () {
      var isReferenceCheckActive = $(
        '.modal-delete__references-notice-container--active .modal-delete__references-checkbox-container[data-checked="1"]'
      ).length;
      if (hasReferences && !isReferenceCheckActive) {
        animateEl(app.confirmDeleteModal.wrapper, 'shake');
      } else {
        deleteRequest(ids, model, force);
      }
    });

  // Open
  app.confirmDeleteModal.open();
}

// Request to delete

function deleteRequest(ids, model, force) {
  $.ajax({
    url: '/admin/request/delete',
    method: 'post',
    data: {
      ids: ids,
      model: model,
      force: force
    },
    headers: {
      'X-CSRF-TOKEN': $('#csrf-token').val()
    },
    beforeSend: function () {
      app.confirmDeleteModal.disableForm();
      app.confirmDeleteModal.addLoadingStatus();
    },
    success: function (response) {
      app.confirmDeleteModal.removeLoadingStatus();
      if (response && response.success) {
        app.confirmDeleteModal.close();
        var selector = getMultiSelectRowsSelector(ids);
        $(selector).fadeOut(500, function () {
          $(this).remove();
          showSelectedItems();
          checkEmptyListMessage();
          success(getMultiSelectSuccessMessage(ids, 'gelöscht'));
        });
        return;
      }
      app.confirmDeleteModal.enableForm();
      animateEl($('.modal-delete__submit-button'), 'shake');
      error();
    },
    error: function () {
      app.confirmDeleteModal.enableForm();
      app.confirmDeleteModal.removeLoadingStatus();
      animateEl($('.modal-delete__submit-button'), 'shake');
      ajaxError();
    }
  });
}
